import { useEffect, useState } from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { Facet } from '../shared/Facet';
import { PHASES_LIST } from '../shared/AppConstants';

const PhasesFilter = (props) => {
  const [phaseList, setPhaseList] = useState(
    PHASES_LIST.map((phase, index) => ({
      id: index + 1,
      name: phase,
      checked: false
    }))
  );
  const { setParentFilter } = props.commonProps;
  const { setSelectedPhases, selectedValues } = props;

  const processChange = (updatedList, setONParent) => {
    let selectedPhases = [];
    let selectedPhaseIds = [];

    updatedList.forEach((element) => {
      if (element.checked) {
        selectedPhases.push(element.name);
        selectedPhaseIds.push(element.id);
      }
    });

    setSelectedPhases(selectedPhaseIds);
    if (setONParent && setParentFilter) {
      setParentFilter({ phaseFilter: selectedPhases });
    }
  };

  useEffect(() => {
    if (selectedValues) {
      const updatedPhaseList = phaseList.map((element) => ({
        ...element,
        checked: selectedValues.includes(element.name)
      }));
      setPhaseList(updatedPhaseList);
      processChange(updatedPhaseList, false);
    }
  }, [selectedValues]);

  const onChangeHandler = (item) => {
    const updated = phaseList.map((element) =>
      item.name === element.name
        ? { ...element, checked: !element.checked }
        : element
    );
    setPhaseList(updated);
    processChange(updated, true);
  };

  const clearPhaseSelection = () => {
    const cleared = phaseList.map((record) => ({ ...record, checked: false }));
    setPhaseList(cleared);
    processChange(cleared, true);
  };

  const selectedPhaseCount = phaseList.filter((phase) => phase.checked).length;

  return (
    <Facet>
      <Facet.Item
        id="phase_filter"
        title="Phase"
        selectedItems={[]}
        selectedCount={selectedPhaseCount}
        clearSelection={clearPhaseSelection}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {phaseList.map((currentRecord) => {
            return (
              <FormControlLabel
                key={currentRecord.name}
                label={currentRecord.name}
                control={
                  <Checkbox
                    id={currentRecord.name}
                    checked={currentRecord.checked}
                    onChange={() => onChangeHandler(currentRecord)}
                  />
                }
              />
            );
          })}
        </Box>
      </Facet.Item>
    </Facet>
  );
};
export default PhasesFilter;
